module.exports = __webpack_public_path__ + "img/12_63.1328d59b.png";